import { createStore } from '@orderx/lab/xr/store';
import { useEffect } from 'react';

const store = createStore({
    hasPlaceholder: true,
});

export function useLayoutFooter() {
    const [state, setState] = store.useStore();

    return {
        useHidePlaceholderOnCurrentPage() {
            useEffect(() => {
                setState((state) => {
                    state.hasPlaceholder = false;
                });

                return () => {
                    setState((state) => {
                        state.hasPlaceholder = true;
                    });
                };
            }, []);
        },
        hasPlaceholder() {
            return state.hasPlaceholder;
        },
    };
}
